var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 357,
    viewBox: "0 0 250 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.973 4.45337C51.182 -21.5333 2.57805 105.513 1 172.284C34.139 210.182 105.151 199.353 143.024 183.112C180.898 166.87 209.302 134.386 232.973 74.8337C251.91 27.1914 256.644 9.86697 232.973 4.45337Z",
    fill: "url(#paint0_linear_1910_495)",
    stroke: "#DEFF04",
    strokeOpacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4556 338.768C3.168 314.362 0.503506 270.693 2.2072 251.909C46.8608 244.077 72.6287 265.579 76.9658 269.937C81.3028 274.295 84.3638 280.299 85.8943 283.301L85.8944 283.301C118.29 350.99 57.815 369.276 27.4556 338.768Z",
    fill: "url(#paint1_linear_1910_495)",
    stroke: "#DEFF04",
    strokeOpacity: 0.14
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1910_495",
    x1: 38.8732,
    y1: 190.486,
    x2: 248.189,
    y2: 39.4821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ED21",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#DEFF04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1910_495",
    x1: 6.54428,
    y1: 256.267,
    x2: 82.2048,
    y2: 330.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F7FD",
    stopOpacity: 0.76
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.f8ebfc5119d7ecf2a9c3b9b198c3a8f6.svg";
export { ForwardRef as ReactComponent };